<template>
  <div class="company-page">
    <div
      v-if="$can('create', 'company')"
      class="btn-actions-content"
    >
      <b-button
        class="btn-grad d-flex align-items-center"
        @click="openModal()"
      >
        <VSIcons
          name="AddSquare"
          width="22"
          height="22"
          class="pr-2"
        />
        <span class="align-middle">Adicionar</span>
      </b-button>
    </div>
    <b-input-group class="input-group-merge round search-input-filter">
      <b-input-group-prepend
        is-text
      >
        <VSIcons
          name="Search"
          color="#7D8E9E"
          width="18"
          height="18"
        />
      </b-input-group-prepend>
      <b-form-input
        id="filter-input"
        v-model="filter"
        placeholder="Buscar..."
        type="search"
      />
    </b-input-group>
    <b-table
      id="company-table"
      ref="companyTable"
      class="module-table mt-4"
      :items="items"
      :fields="fields"
      :filter="filter"
      :filter-included-fields="filterOn"
      :busy="apiInCall"
      :per-page="perPage"
      :current-page="currentPage"
      hover
      empty-filtered-text="Não há resultados para sua pesquisa."
      empty-text="Não há registros para serem exibidos."
      responsive
      details-td-class="align-middle"
      selectable
      show-empty
      @filtered="onFiltered"
      @row-selected="detailItemTable"
    >
      <template #table-busy>
        <b-spinner variant="primary" />
      </template>
      <template
        v-if="$can('delete', 'company')"
        #head(select)
      >
        <b-form-checkbox
          v-model="allSelected"
          :indeterminate="indeterminate"
          @change="toggleAll('system/companies', 'Company')"
        />
      </template>
      <template #cell(cnpj)="row">
        {{ row.item.isLegalPerson ? formatCpfCnpj(row.item.cnpj) : formatCpfCnpj(row.item.cpf) }}
      </template>
      <template #cell(nome_fantasia)="row">
        {{ row.item.isLegalPerson ? row.item.nome_fantasia : row.item.full_name }}
      </template>
      <template
        v-if="$can('delete', 'company')"
        #cell(select)="row"
      >
        <b-form-checkbox
          v-model="selected"
          :value="row.item"
          @change="setItensToDelete({ itens: selected, api: 'system/companies', fetchTable: 'Company' })"
        />
      </template>
      <template #cell(sector)="row">
        {{ row.item.sector.name ? row.item.sector.name : 'Não especificado' }}
      </template>
      <template #cell(responsavel)="row">
        {{ row.item.contact_name }}
      </template>
      <template #cell(empreendimento)="row">
        {{ row.item.projects.length }}<VSIcons
          class="ml-1"
          name="BriefcaseFillGradient"
        />
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="company-table"
    >
      <template #prev-text>
        <VSIcons name="ArrowLeft" />
      </template>
      <template #next-text>
        <VSIcons name="ArrowRight" />
      </template>
    </b-pagination>
    <VSModal
      width="500"
      name="Import"
      :draggable="false"
    />
  </div>
</template>

<script>
import {
  BInputGroup, BInputGroupPrepend, BFormInput, BTable, BButton, BFormCheckbox, BSpinner, BPagination,
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { tableConfig } from '@core/mixins/ui/forms'
import VSIcons from '@/assets/icons/VSIcons.vue'
import VSModal from '@/components/modals/VSModal.vue'

export default {
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BTable,
    BButton,
    VSIcons,
    BFormCheckbox,
    BSpinner,
    BPagination,
    VSModal,
  },
  mixins: [
    tableConfig,
  ],
  data() {
    return {
      fields: [
        {
          label: '',
          key: 'select',
        },
        {
          label: 'Nome',
          key: 'nome_fantasia',
          sortable: true,
          tdClass: 'align-middle to-uppercase',
        },
        {
          label: 'Razão Social',
          key: 'razao_social',
          sortable: true,
          tdClass: 'align-middle to-uppercase',
        },
        {
          label: 'CNPJ/CPF',
          key: 'cnpj',
          sortable: true,
          tdClass: 'align-middle to-uppercase',
        },
        {
          label: 'Setor',
          key: 'sector',
          sortable: true,
          tdClass: 'align-middle to-uppercase',
        },
        {
          label: 'Responsável',
          key: 'contact_name',
          sortable: true,
          tdClass: 'align-middle to-uppercase',
        },
        {
          label: 'Empreendimento',
          key: 'empreendimento',
          sortable: true,
          tdClass: 'd-flex align-middle j-c-center to-uppercase',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({ apiInCall: 'app/getApiInCall', items: 'company/getCompanies' }),
  },
  created() {
    this.fetchCompanies()
  },
  methods: {
    ...mapMutations({ setItensToDelete: 'app/SET_ITENS_DELETE' }),
    ...mapActions({ fetchCompanies: 'company/fetchCompanies' }),
    createCompany() {
      this.$router.push('empresa/adicionar/detalhes')
    },
    openModal() {
      this.showModal('Import')
    },
    formatCpfCnpj(value) {
      if (value && value.length === 14) {
        return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      }
      if (value && value.length === 11) {
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      }
      return value
    },
  },
}
</script>
